module.exports = __webpack_public_path__ + "img/service_mobiledev.28982771.jpg";